import React, { memo, useState } from "react"
import Title from "./Title"
import Paragraph from "./Paragraph"
import Table from "./Table"
import List from "./List"
import IntroData from "./IntroData/IntroData"
import BookData from "./BookData"
import BibleEffectVideo from "./BibleEffectVideo"
import BibleProjectVideos from './BibleProjectVideos'
import RecommendedResources from "./RecommendedResources"

const Introduction2 = memo(
  ({ content, bookData, segmentID, book, alignment, language, version }) => {
    const [showRR, setShowRR] = useState(false);

    return (
      <div>
        <div style={alignment ? { textAlign: "right", direction: "rtl" } : {}}>
          {content.map((block, index) => {
            const { id } = block
            if (
              block.type === "ht" ||
              block.type === "hs" ||
              block.type[0] === "s"
            ) {
              return (
                <Title
                  id={id}
                  key={`${index}-${block.type}`}
                  content={block.children}
                  index={index}
                  type={block.type}
                />
              )
            }
            if (block.type === "paragraph") {
              return (
                <Paragraph
                  id={id}
                  key={`${index}-${block.type}`}
                  content={block.children}
                  index={index}
                />
              )
            }
            if (block.type === "table") {
              return (
                <Table
                  id={id}
                  key={`${index}-${block.type}`}
                  content={block.children}
                  index={index}
                  book={book}
                />
              )
            }
            if (
              block.type === "bulleted-list" ||
              block.type === "numbered-list"
            ) {
              return (
                <List
                  id={id}
                  key={`${index}-${block.type}`}
                  content={block.children}
                  index={index}
                  type={block.type}
                />
              )
            }
            console.log(block)
            return <p>ERROR</p>
          })}
        </div>
        {bookData && (
          <div style={{ marginTop: 40, direction: alignment ? "rtl" : "ltr" }}>
            <BookData
              sources={bookData.sources}
              colors={bookData.colors}
              alignment={alignment}
            />
          </div>
        )}
        {book && (
          <div style={alignment ? { direction: "rtl" } : {}}>
            <IntroData book={book} />
          </div>
        )}
        <RecommendedResources
          selectedLanguage={language}
          book={book}
          showRR={showRR}
        />
        <BibleEffectVideo
          language={language}
          version={version}
          book={book}
          setShowRR={setShowRR}
        />
        <BibleProjectVideos
          language={language}
          book={book}
          version={version}
          setShowRR={setShowRR}
        />
      </div>
    )
  }
)

export default Introduction2
